import { render, staticRenderFns } from "./DismantleForm.vue?vue&type=template&id=6b3bd6aa&"
import script from "./DismantleForm.vue?vue&type=script&lang=js&"
export * from "./DismantleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports